import React, { useState } from 'react';
import { Link} from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, InputGroup, InputGroupAddon, InputGroupText, FormFeedback } from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { useTranslation, Trans } from 'react-i18next';
import * as Yup from "yup";
import { useFormik } from 'formik';
import InputWithLoader from './InputWithLoader';
import { useRedeemCoupon } from '../api/hooks/coupons';

const RedeemCouponSchema = Yup.object().shape({
  code: Yup.string().required("Required"),
});

const RedeemCouponModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;
  const { t } = useTranslation('common')
  const [modal, setModal] = useState(false);
  const { mutate: redeemCouponMutate } = useRedeemCoupon();

  const formik = useFormik({
    initialValues: { code: '' },
    validationSchema: RedeemCouponSchema,
    onSubmit: (values, actions) => {
      redeemCouponMutate(values, {
        onSettled: () => {
          actions.setSubmitting(false)
        }
      })
    }
  });

  const toggle = () => setModal(!modal);

  return (
    <div>
      <div className="text-dark" onClick={toggle}>
        <FontAwesomeIcon className="text-primary mr-2" icon="tag" /> {t('redeemCoupon')}
      </div>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{t('redeemCoupon')}</ModalHeader>
        <ModalBody className="text-center">
        <FormGroup>
          <Label for="">
            {t("forms.coupon")}
          </Label>
          <InputGroup className="mb-2">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <FontAwesomeIcon icon="tag" className="muted mx-auto" />
              </InputGroupText>
            </InputGroupAddon>
            <InputWithLoader
              className="border-left-0 rounded-right"
              type="text"
              id="code"
              placeholder={t("forms.coupon")}
              name="code"
              loading={formik.isSubmitting}
              onChange={formik.handleChange}
              value={formik.values.code}
              invalid={
                formik.errors.code && formik.touched.code
              }
            />
            <FormFeedback>
              {t(`errors.${formik.errors.code}`)}
            </FormFeedback>
          </InputGroup>
        </FormGroup>
          
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" className="mx-auto" onClick={toggle}>{t('actions.close')}</Button>
          <Button color="accent" className="mx-auto" onClick={formik.handleSubmit}>{t('actions.submit')}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default RedeemCouponModal;